import {
  AppealDetailApiResponse,
  AppealDetailDetails,
  FetchAppealDetailParams,
} from "../../data-model/appealDetail";
import { API_ENDPOINTS } from "../../enums/apiUrls";
import { logError } from "../../utils/customLogger";
import { getBearerToken } from "./bearerToken";

/**
 * Fetches appeal record and event history for the Appeal Info side panel History tab.
 *
 * @param params - Order identifier
 * @returns Parsed detail payload with appeal record and events
 * @throws {Error} When auth is missing or the API returns a non-OK status
 */
export const fetchAppealDetail = async (
  params: FetchAppealDetailParams,
): Promise<AppealDetailDetails> => {
  try {
    const token = await getBearerToken();
    if (!token) {
      throw new Error("Bearer token not available");
    }

    const response = await fetch(API_ENDPOINTS.APPEAL_DETAIL, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({ identifier: params.identifier }),
    });

    const responseText = await response.text();
    let parsed: AppealDetailApiResponse = {};

    if (responseText.trim()) {
      try {
        parsed = JSON.parse(responseText) as AppealDetailApiResponse;
      } catch {
        parsed = { message: responseText };
      }
    }

    if (!response.ok) {
      throw new Error(
        parsed.message ||
          `Failed to fetch appeal detail: ${response.status} - ${responseText}`,
      );
    }

    return parsed.details ?? {};
  } catch (error) {
    logError(error as Error, "fetchAppealDetail");
    throw error;
  }
};
